import { getNumericRiskValue } from 'src/hooks/useDashboardFilters';

const descendingComparator = (
  a: any,
  b: any,
  orderBy: string,
  riskKeyByTitleMap: Record<string, string>
) => {
  if (!orderBy) {
    return 0;
  }

  const orderByKey = riskKeyByTitleMap[orderBy];

  const getValue = (item: any) =>
    orderBy.toLocaleLowerCase() === 'name'
      ? item.show
      : orderBy.toLocaleLowerCase() === 'episode title'
      ? item['Episode Title'].toLocaleLowerCase()
      : item[orderByKey]?.id
      ? getNumericRiskValue(item[orderByKey]?.medianRisk)
      : getNumericRiskValue(item[orderByKey]);
  if (
    orderBy.toLocaleLowerCase() === 'name' ||
    orderBy.toLocaleLowerCase() === 'episode title'
  ) {
    return getValue(b) > getValue(a) ? 1 : -1;
  } else if (orderBy.toLocaleLowerCase() === 'episode date') {
    const aDate = new Date(a['Episode Date']).getTime() || 0;
    const bDate = new Date(b['Episode Date']).getTime() || 0;
    return bDate > aDate ? 1 : -1;
  } else {
    return getValue(b) - getValue(a);
  }
};

export const getComparator = (
  order: 'desc' | 'asc' | undefined,
  orderBy: string,
  riskKeyByTitleMap: Record<string, string>
) => {
  return order === 'desc'
    ? (a: any, b: any) => descendingComparator(a, b, orderBy, riskKeyByTitleMap)
    : (a: any, b: any) =>
        -descendingComparator(a, b, orderBy, riskKeyByTitleMap);
};

export const stableSort = (array: any[], comparator: any) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const decodePercentU = (str: string) => {
  return str.replace(/%u([0-9A-F]{4})/gi, (_, code) =>
    String.fromCharCode(parseInt(code, 16))
  );
};
